// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "d2fa80d4" + "." + "233ce5f6fb4572bb" + ".js";
};